<template>
  <div class="chat-avatar" :class="shape === 'circle' ? 'shape-circle' : ''">
    <img :src="avatarSrc" :onerror="errorUserPhoto">
  </div>
</template>

<script>
import systemAvatar from '@/assets/image/system.png';
import userPhoto from '@/assets/image/cl_user_avatar.png';
export default {
  props: {
    src: String,
    type: {
      type: String,
      default: 'C2C'
    },
    shape: {
      type: String,
      default: 'circle'
    }
  },
  data() {
    return {
      errorUserPhoto: 'this.src="' + userPhoto + '"',
    }
  },
  computed: {
    avatarSrc: function () {
      let src = this.src
      if (/^(https:|http:|\/\/)/.test(src)) {
        return src
      } else {
        return this.defaultSrc
      }
    },
    defaultSrc: function () {
      switch(this.type) {
        case 'C2C':
          // 个人头像
          return 'http://148.70.221.198/pc/image/cl_user_avatar.png'
        case 'GROUP':
          // 群默认头像
          return 'http://148.70.221.198/pc/image/cl_group_avatar.png'
        case this.TIM.TYPES.CONV_SYSTEM:
          return systemAvatar
        default:
          // 默认头像
          return 'http://148.70.221.198/pc/image/cl_user_avatar.png'
      }
    }
  }
}
</script>

<style>
.chat-avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
  /* box-shadow: 0 5px 10px 0 rgba(0,0,0,.1); */
}

.chat-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
</style>
